import { render } from "./PartsFlow.vue?vue&type=template&id=b52ffb16&scoped=true"
import script from "./PartsFlow.vue?vue&type=script&lang=js"
export * from "./PartsFlow.vue?vue&type=script&lang=js"

import "./PartsFlow.vue?vue&type=style&index=0&id=b52ffb16&scoped=true&lang=css"
import "./PartsFlow.vue?vue&type=style&index=1&id=b52ffb16&lang=css"

import exportComponent from "/Users/maru/Desktop/東野材木/hojokin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b52ffb16"]])

export default __exports__